import React from 'react';
import { Row, Col } from 'react-styled-flexboxgrid';
import PropTypes from 'prop-types';
import { Line } from '@vds/lines';
import { Title, Body } from '@vds/typography';

import { Margin } from '../../../common/styles';
import { isMobile } from '../../../common/Helpers/useragent';
import { formatMtnWithDecimals } from '../NextBillsUtils';

const NBSMonthlyBill = (props) => {
  const nbsVo = props.data || {};

  const {
    pendingChargesAndDiscounts = '',
    pendingChargesAndDiscounts: {
      discountsPendingActionDetails: {
        deviceTradeInDetails = '',
        otherDeviceTradeInDetail = '',
        apoPaperlessAmount = '',
        newMonthlyTotalWithPendingDiscounts = '',
      } = {},
    } = {},
  } = nbsVo || {};

  return (
    <div data-testid="NBSMonthlyBill">
      {pendingChargesAndDiscounts && (apoPaperlessAmount || deviceTradeInDetails.length !== 0 || otherDeviceTradeInDetail) && (
        <div>
          <Margin top="20px">
            <Line type="primary" />
            <Margin top="8px">
              <Title size="medium" primitive="h3" bold>
                {props.MonthlyBill}
              </Title>
            </Margin>
          </Margin>

          {apoPaperlessAmount && apoPaperlessAmount !== undefined && apoPaperlessAmount.length !== 0 && (
            <>
              <Margin top="20px" bottom="20px">
                <Row style={{ maxWidth: '100%' }}>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Body size={isMobile() ? 'medium' : 'large'} primitive="p" bold>
                      {props.Autopay}
                    </Body>
                  </Col>
                </Row>

                <Margin top="8px">
                  <Row style={{ maxWidth: '100%' }}>
                    <Col xs={8} sm={8} md={8} lg={8}>
                      <Body size={isMobile() ? 'medium' : 'large'} primitive="p">
                        {props.AutoPayDesc}
                        {props.AutoPayLink}
                      </Body>
                    </Col>
                    <Col xs={4} sm={4} md={4} lg={4} style={{ textAlign: 'right' }}>
                      <Body size={isMobile() ? 'medium' : 'large'} primitive="p">
                        {apoPaperlessAmount && apoPaperlessAmount !== undefined && apoPaperlessAmount > 0 ? (
                          <>
                            ${apoPaperlessAmount}
                            /mo
                          </>
                        ) : null}
                        {apoPaperlessAmount && apoPaperlessAmount !== undefined && apoPaperlessAmount < 0 ? (
                          <>
                            -$
                            {parseFloat(Math.abs(apoPaperlessAmount)).toFixed(2)}
                            /mo
                          </>
                        ) : null}
                        {apoPaperlessAmount && apoPaperlessAmount !== undefined && apoPaperlessAmount === '0' ? <>$0.00/mo</> : null}
                      </Body>
                    </Col>
                  </Row>
                </Margin>
              </Margin>
              <Line type="secondary" />
            </>
          )}
          {deviceTradeInDetails.length !== 0 &&
            deviceTradeInDetails.map((item) => (
              <>
                <Margin top="20px" bottom="20px">
                  <Row style={{ maxWidth: '100%' }}>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Body size={isMobile() ? 'medium' : 'large'} primitive="p" bold>
                        {props.DeviceTradeIn}
                      </Body>
                      <Body size={isMobile() ? 'medium' : 'large'} primitive="p">
                        {formatMtnWithDecimals(item.deviceTradeInMtn)}
                      </Body>
                    </Col>
                  </Row>

                  <Margin top="8px">
                    <Row style={{ maxWidth: '100%' }}>
                      <Col xs={8} sm={8} md={8} lg={8}>
                        <Body size={isMobile() ? 'medium' : 'large'} primitive="p">
                          {props.DeviceText}
                        </Body>
                      </Col>
                      <Col xs={4} sm={4} md={4} lg={4} style={{ textAlign: 'right' }}>
                        <Body size={isMobile() ? 'medium' : 'large'} primitive="p">
                          {item.deviceTradeInAmount && item.deviceTradeInAmount !== undefined && item.deviceTradeInAmount > 0 ? (
                            <>
                              {`$${item.deviceTradeInAmount}`}
                              /mo
                            </>
                          ) : null}
                          {item.deviceTradeInAmount && item.deviceTradeInAmount !== undefined && item.deviceTradeInAmount < 0 ? (
                            <>
                              -$
                              {parseFloat(Math.abs(item.deviceTradeInAmount)).toFixed(2)}
                              /mo
                            </>
                          ) : null}
                          {item.deviceTradeInAmount && item.deviceTradeInAmount !== undefined && item.deviceTradeInAmount === '0' ? (
                            <>$0.00/mo</>
                          ) : null}
                        </Body>
                      </Col>
                    </Row>
                  </Margin>
                </Margin>
                <Line type="secondary" />
              </>
            ))}
          {otherDeviceTradeInDetail && (
            <>
              <Margin top="20px" bottom="20px">
                <Row style={{ maxWidth: '100%' }}>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Body size={isMobile() ? 'medium' : 'large'} primitive="p" bold>
                      {props.DeviceTradeIn}
                    </Body>
                  </Col>
                </Row>

                <Margin top="8px">
                  <Row style={{ maxWidth: '100%' }}>
                    <Col xs={8} sm={8} md={8} lg={8}>
                      <Body size={isMobile() ? 'medium' : 'large'} primitive="p">
                        {props.OtherDeviceText1}
                        {otherDeviceTradeInDetail.otherDeviceCounter}
                        {props.OtherDeviceText2}
                      </Body>
                    </Col>
                    <Col xs={4} sm={4} md={4} lg={4} style={{ textAlign: 'right' }}>
                      <Body size={isMobile() ? 'medium' : 'large'} primitive="p">
                        -$
                        {parseFloat(Math.abs(otherDeviceTradeInDetail.otherDeviceTradeInAmount)).toFixed(2)}
                        /mo
                      </Body>
                    </Col>
                  </Row>
                </Margin>
              </Margin>
              <Line type="secondary" />
            </>
          )}
          <>
            <Margin top="20px">
              <Row style={{ maxWidth: '100%' }}>
                <Col xs={9} sm={9} md={9} lg={9}>
                  <Body size="large" primitive="p" bold>
                    {props.BillEstimatedText}
                  </Body>
                  {(deviceTradeInDetails.length !== 0 || otherDeviceTradeInDetail) && (
                    <Body size="large" primitive="p">
                      {props.TradeInValues}
                    </Body>
                  )}
                </Col>
                <Col xs={3} sm={3} md={3} lg={3} style={{ textAlign: 'right' }}>
                  <Body size="large" primitive="p" bold>
                    {`$${newMonthlyTotalWithPendingDiscounts}`}
                    {(deviceTradeInDetails.length !== 0 || otherDeviceTradeInDetail) && '*'}
                  </Body>
                </Col>
              </Row>
            </Margin>
          </>
        </div>
      )}
    </div>
  );
};

NBSMonthlyBill.defaultProps = {
  MonthlyBill: 'How to lower your monthly bill',
  Autopay: 'Auto Pay',
  AutoPayDesc: 'Don’t forget, you can save on your monthly bill by enrolling in paper-free billing and Auto Pay. Learn more on ',
  AutoPayLink: 'go.vzw.com/gopaperfree',
  DeviceTradeIn: 'Device trade-in',
  DeviceText: 'Don’t forget, your device needs to be sent in to receive your trade-in credit',
  OtherDeviceText1: 'Don’t forget, your ',
  OtherDeviceText2: ' devices need to be sent in to receive your trade-in credits.',
  BillEstimatedText: 'New monthly bill estimate if promotions are applied',
  TradeInValues: '*based on estimated trade-in value',
};

NBSMonthlyBill.propTypes = {
  data: PropTypes.object,
  MonthlyBill: PropTypes.string,
  Autopay: PropTypes.string,
  AutoPayDesc: PropTypes.string,
  AutoPayLink: PropTypes.string,
  DeviceTradeIn: PropTypes.string,
  DeviceText: PropTypes.string,
  OtherDeviceText1: PropTypes.string,
  OtherDeviceText2: PropTypes.string,
  BillEstimatedText: PropTypes.string,
  TradeInValues: PropTypes.string,
};

export default React.memo(NBSMonthlyBill);
